import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { DownOutlined } from '@ant-design/icons';
import { Dropdown } from 'antd';
import { Button } from 'ui/styled';
export var DEFAULT_TITLE = 'Gender';
var ANY = 'any';
var MALE = 'm';
var FEMALE = 'f';
var items = [
    {
        key: ANY,
        label: 'Any'
    },
    {
        key: MALE,
        label: 'Male'
    },
    {
        key: FEMALE,
        label: 'Female'
    }
];
var getTitleByKey = function (key) {
    var item = items.find(function (i) { return i.key === key; });
    if (!item || key === 'any')
        return DEFAULT_TITLE;
    return "".concat(DEFAULT_TITLE, ": ").concat(item.label);
};
var GenderDropdown = function (_a) {
    var defaultValue = _a.defaultValue, onSelect = _a.onSelect, _b = _a.dataTest, dataTest = _b === void 0 ? 'GenderDropdown' : _b;
    var _c = useState(getTitleByKey(defaultValue)), title = _c[0], setTitle = _c[1];
    var onClick = function (item) {
        var key = item === null || item === void 0 ? void 0 : item.key;
        setTitle(getTitleByKey(key));
        onSelect(key);
    };
    return (_jsx(Dropdown, { menu: { items: items, onClick: onClick }, trigger: ['click'], children: _jsxs(Button, { "data-test": dataTest, children: [title, _jsx(DownOutlined, {})] }) }));
};
export default GenderDropdown;
